import React from 'react';
import classes from './Burger.module.css'
import BurgerIngredient from './BurgerIngredient/BurgerIngredient';

const burger = (props) => {

    // converting a object to array of ingredients o
    let tranformIngredients = Object.keys(props.ingredients).map( (igKey) => {
            return [...Array(props.ingredients[igKey])].map( (_, index) => {
                return <BurgerIngredient key={igKey + index} type={igKey}/>
            });
        })
        // to make it flat array from array of array
        .reduce((prevVal, currVal) => {
            return prevVal.concat(currVal);
        }, []);

        console.log('Burger')
        // console.log(tranformIngredients);

    if(tranformIngredients.length === 0) {
        tranformIngredients = <p>Please start adding ingredients!!</p>
    }

    return (
        <div className={classes.Burger}>
            <BurgerIngredient type={'bread-top'}></BurgerIngredient>
            {tranformIngredients}
            <BurgerIngredient type={'bread-bottom'}></BurgerIngredient>
        </div>
    );
};

export default burger;